








import { Component, Vue } from 'vue-property-decorator';
import { RedirectToIntegrationApi } from "../api/redirectToIntegrationApi";

@Component({
  components: {
  },
})

export default class RedirectToIntegration extends Vue {
    public integration?: string;
    public api: RedirectToIntegrationApi;

    constructor() {
        super();

        this.api = new RedirectToIntegrationApi();
    }

    public async created() {
        this.integration = this.$route.params.integration ? this.$route.params.integration as string : undefined;

        if (this.integration == null){
            this.$router.push("/");
            return;
        }

        const integrations = await this.api.getIntegrations();

        const integrationToRedirect = integrations.filter(i => i.id == this.integration)[0];

        if (integrationToRedirect == null) {
            this.$router.push("/");
            return;
        }        
        
        window.location.href = integrationToRedirect.creatorUrl;
    }
}
